/**
 * Adaptive stepper increment (in cm) for the margin numeric inputs.
 *
 * Margins are typically dialled in sub-millimetre near the small, clinically
 * common CTV-to-PTV range, while large margins rarely need that resolution.
 * The step therefore grows with the magnitude of the margin:
 *
 * | margin (cm)   | step      |
 * |---------------|-----------|
 * | [0, 0.5)      | 0.05 cm   (0.5 mm) |
 * | [0.5, 2)      | 0.10 cm   (1.0 mm) |
 * | [2, +inf)     | 0.25 cm   (2.5 mm) |
 *
 * Used together with `NumberInput`'s `snapToStep`, the arrows always land on a
 * grid line for the active band (e.g. 0.22 -> 0.25, 0.95 -> 1.00 -> 1.10).
 *
 * @param valueCm current margin value in cm
 * @returns the step to apply, in cm
 */
export function marginStepCm(valueCm: number): number {
    const magnitude = Math.abs(valueCm);
    if (magnitude < 0.5) {
        return 0.05;
    }
    if (magnitude < 2) {
        return 0.1;
    }
    return 0.25;
}
